<template>
  <div class="home">
    <Section light>
      <v-col cols="12">
        <div>
          <h1>Officers</h1>
        </div>
      </v-col>

      <v-col cols="12">
        <div>
          <h2 class="president-title">President</h2>
        </div>
      </v-col>
      <v-row justify="center">
        <Member
          v-for="member in officersPresident"
          :key="member[0]"
          :name="member[0]"
          :picture="member[1]"
          :portrait="true"
        />
      </v-row>

      <v-col cols="12">
        <div>
          <h2>Sub-team Leads</h2>
        </div>
      </v-col>
      <v-col cols="12">
        <div>
          <h3 class="subteam-title">Software</h3>
        </div>
      </v-col>
      <v-row justify="center">
        <Member
          v-for="member in officersLeadsSoftware"
          :key="member[0]"
          :name="member[0]"
          :picture="member[1]"
          :portrait="true"
        />
      </v-row>

      <v-col cols="12">
        <div>
          <h3 class="subteam-title">Mechanical</h3>
        </div>
      </v-col>
      <v-row justify="center">
        <Member
          v-for="member in officersLeadsMech"
          :key="member[0]"
          :name="member[0]"
          :picture="member[1]"
          :portrait="true"
        />
      </v-row>

      <v-col cols="12">
        <div>
          <h3 class="subteam-title">Science</h3>
        </div>
      </v-col>
      <v-row justify="center">
        <Member
          v-for="member in officersLeadsScience"
          :key="member[0]"
          :name="member[0]"
          :picture="member[1]"
          :portrait="true"
        />
      </v-row>

      <v-col cols="12">
        <div>
          <h3 class="subteam-title">Electrical</h3>
        </div>
      </v-col>
      <v-row justify="center">
        <Member
          v-for="member in officersLeadsElectrical"
          :key="member[0]"
          :name="member[0]"
          :picture="member[1]"
          :portrait="true"
        />
      </v-row>

      <v-col cols="12">
        <div>
          <h3 class="subteam-title">Lead Testing Technician</h3>
        </div>
      </v-col>
      <v-row justify="center">
        <Member
          v-for="member in officersTesting"
          :key="member[0]"
          :name="member[0]"
          :picture="member[1]"
          :portrait="true"
        />
      </v-row>

      <v-col cols="12">
        <div>
          <h1>Our Members</h1>
        </div>
        <div class="image-container">
          <img src="@/assets/members/SoftwareGroup.jpg" alt="Software group" loading="lazy" />
        </div>
        <div class="image-container">
          <img src="@/assets/members/MechanicalGroup.jpg" alt="Mechanical group" loading="lazy" />
        </div>
      </v-col>
      <Member v-for="member in pm" :key="member[0]" :name="member[0]" :picture="member[1]" />
      <v-col cols="12">
        <div>
          <h1>Electrical</h1>
        </div>
      </v-col>
      <Member
        v-for="member in electrical"
        :key="member[0]"
        :name="member[0]"
        :picture="member[1]"
      />
      <v-col cols="12">
        <div>
          <h1>Mechanical</h1>
        </div>
      </v-col>
      <Member
        v-for="member in mechanical"
        :key="member[0]"
        :name="member[0]"
        :picture="member[1]"
      />
      <v-col cols="12">
        <div>
          <h1>Science</h1>
        </div>
      </v-col>
      <Member v-for="member in science" :key="member[0]" :name="member[0]" :picture="member[1]" />
      <v-col cols="12">
        <div>
          <h1>Non-Technical</h1>
        </div>
      </v-col>
      <Member v-for="member in nontech" :key="member[0]" :name="member[0]" :picture="member[1]" />
      <v-col cols="12">
        <div>
          <h1>Software</h1>
        </div>
      </v-col>
      <Member v-for="member in software" :key="member[0]" :name="member[0]" :picture="member[1]" />
    </Section>
  </div>
</template>

<script>
import Section from "@/components/Section.vue";
import Member from "@/components/Member.vue";

export default {
  name: "Mechanical",
  components: {
    Section,
    Member,
  },
  created() {
    this.pm = [
      ["Dylan Lee", "2025-2026/mech/dylan.jpg"],
      ["Daniel Zhang", "2025-2026/science/Daniel_Zhang.jpg"],
      ["Jimena Escuin", "2025-2026/electrical/Jimena_Escuin.jpg"],
    ];
    this.electrical = [
      ["Ethan Dauz", "2025-2026/electrical/Ethan Dauz.jpg"],
      ["Gabriela Jaramillo", "2025-2026/electrical/Gabriela_Jaramillo.jpg"],
      ["Isaac Wang", "2025-2026/electrical/Isaac Wang.jpg"],
      ["Jimena Escuin", "2025-2026/electrical/Jimena_Escuin.jpg"],
      ["Khadija Raza", "2025-2026/electrical/Khadija_Raza.jpg"],
      ["Lomax Canfield", "2025-2026/electrical/Lomax_Canfield.jpg"],
      ["Pax Poonapanont", "2025-2026/electrical/Pax_Poonapanont.jpg"],
      ["Rylee Correa", "2025-2026/electrical/Rylee Correa.jpg"],
      ["Stanley Pan", "2025-2026/electrical/Stanley_Pan.jpg"],
      ["Weston Prosser", "2025-2026/electrical/Weston_Prosser.jpg"],
      ["Yufei Li", "2025-2026/electrical/Yufei Li.jpg"],
    ];

    this.mechanical = [
      ["Alan Tsai", "2025-2026/mech/alan.jpg"],
      ["Blase Londoño", "2025-2026/mech/blase.jpg"],
      ["Charu", "2025-2026/mech/charu.jpg"],
      ["Chehak Aggarwal", "2025-2026/mech/chehak.jpg"],
      ["Dylan Lee", "2025-2026/mech/dylan.jpg"],
      ["Katie Valentine", "2025-2026/mech/katie_valentine.jpg"],
      ["Kelly Gao", "2025-2026/mech/kelly.jpg"],
      ["Kenneth Foead", "2025-2026/mech/kenneth.jpg"],
      ["Madeleine Chang", "2025-2026/mech/madeleine.jpg"],
      ["Miguel Acosta", "2025-2026/mech/miguel.jpg"],
      ["Abdulrahman Alharthi", "2025-2026/mech/Abdulrahman Alharthi.jpg"],
      ["Shao Duan", "2025-2026/mech/shao.jpg"],
      ["Sherwin Salemi", "2025-2026/mech/sherwin.jpg"],
      ["Sydney Hodge", "2025-2026/mech/sydney.jpg"],
      ["Tab Zaman", "2025-2026/mech/tab.jpg"],
      ["Yahya Mirza", "2025-2026/mech/yahya.jpg"],
    ];

    this.science = [
      ["Akira Ohara", "2025-2026/science/Akira_Ohara.jpg"],
      ["Ananya Thota", "2025-2026/science/Ananya_Thota.jpg"],
      ["Ankita Bhargava", "2025-2026/science/Ankita_Bhargava.jpg"],
      ["Christina Ouyang", "2025-2026/science/Christina_Ouyang.jpg"],
      ["Daniel Zhang", "2025-2026/science/Daniel_Zhang.jpg"],
      ["Diya Jaishankar", "2025-2026/science/Diya_Jaishankar.jpg"],
      ["Eddy Meals", "2025-2026/science/Eddy_Meals.jpg"],
      ["Neo Teigen", "2025-2026/science/Neo_Teigen.jpg"],
      ["Nina Marie Zinke", "2025-2026/science/Nina Marie Zinke.jpg"],
      ["Sophia Liu", "2025-2026/science/Sophia_Liu.jpg"],
      ["Tram Tran", "2025-2026/science/Tram_Tran.jpg"],
      ["Tyler Bui", "2025-2026/science/Tyler_Bui.jpg"],
    ];

    this.nontech = [
      ["Angel Yan", "2025-2026/nontech/Angel_Yan.jpg"],
      ["Antonio Siliezar", "2025-2026/nontech/Antonio_Siliezar.jpg"],
      ["Harrison Trinh", "2025-2026/nontech/Harrison_Trinh.jpg"],
      ["Hayley Balen", "2025-2026/nontech/Hayley_Balen.jpg"],
      ["Jihee Seo", "2025-2026/nontech/Jihee_Seo.jpg"],
      ["Megha Cherayath", "2025-2026/nontech/Megha_Cherayath.jpg"],
      ["Toshiyuki Joehren", "2025-2026/nontech/Toshiyuki_Joehren.jpg"],
      ["Xuanqi Chen", "2025-2026/nontech/Xuanqi_Chen.jpg"],
    ];

    this.software = [
      ["Herman Hundsberger", "2025-2026/software/herman.jpg"],
      ["Sweekrit Bhatnagar", "2025-2026/software/sweekrit.jpg"],
      ["Alex Meng", "2025-2026/software/alex m.jpg"],
      ["Andrea Calderon", "2025-2026/software/andrea.jpg"],
      ["Arjun Suresh Kumar", "2025-2026/software/arjun.jpg"],
      ["David Gao", "2025-2026/software/David Gao.jpg"],
      ["Edward Yao", "2025-2026/software/edward.jpg"],
      ["Jennifer Kuei", "2025-2026/software/jennifer.jpg"],
      ["John Liu", "2025-2026/software/john.jpg"],
      ["Katelyn Li", "2025-2026/software/katelyn.jpg"],
      ["Nate Murphy", "2025-2026/software/nate.jpg"],
      ["Neil Chaudhury", "2025-2026/software/neil.jpg"],
      ["Pranav Puttagunta", "2025-2026/software/pranav.jpg"],
      ["Saee Phalke", "2025-2026/software/saee.jpg"],
      ["Sierra Myers", "2025-2026/software/sierra.jpg"],
    ];
    // Officers
    this.officersPresident = [["Harrison Trinh", "2025-2026/nontech/Harrison_Trinh.jpg"]];

    this.officersLeadsSoftware = [
      ["Sweekrit Bhatnagar", "2025-2026/software/sweekrit.jpg"],
      ["Herman Hundsberger", "2025-2026/software/herman.jpg"],
      ["Sandul", "2025-2026/software/sandy.jpg"],
    ];

    this.officersLeadsMech = [
      ["Dylan Lee", "2025-2026/mech/dylan.jpg"],
      ["Alan Tsai", "2025-2026/mech/alan.jpg"],
    ];

    this.officersLeadsScience = [["Daniel Zhang", "2025-2026/science/Daniel_Zhang.jpg"]];

    this.officersLeadsElectrical = [
      ["Jimena Escuin", "2025-2026/electrical/Jimena_Escuin.jpg"],
      ["Lomax Canfield", "2025-2026/electrical/Lomax_Canfield.jpg"],
      ["Ethan Dauz", "2025-2026/electrical/Ethan Dauz.jpg"],
    ];

    this.officersTesting = [["Katie Valentine", "2025-2026/mech/katie_valentine.jpg"]];
  },
};
</script>

<style scoped>
h2 {
  text-align: center;
}

.image-container img {
  display: block;
  width: 80%;
  margin: auto;
  padding-top: 20px;
}

.subteam-title {
  text-align: center;
  font-size: 3em;
  margin: 0.25em 0;
}

.president-title {
  text-align: center;
  font-size: 1.6em;
  margin: 0.25em 0;
}
</style>
